const pageNameKey = "resolvedAllNodesPillButton";

export const resolvedAllNodesPillButtonEn = {
  [pageNameKey]: {
    done: "Done",
    indicatorIconAltText: "Indicator Icon",
  },
};

export const resolvedAllNodesPillButtonPtBr = {
  [pageNameKey]: {
    done: "Concluído",
    indicatorIconAltText: "Ícone indicador",
  },
};

export const resolvedAllNodesPillButtonDe = {
  [pageNameKey]: {
    done: "Fertig",
    indicatorIconAltText: "Indikator Icon",
  },
};

export const resolvedAllNodesPillButtonZhHans = {
  [pageNameKey]: {
    done: "完成",
    indicatorIconAltText: "指示器图标",
  },
};

export const resolvedAllNodesPillButtonIt = {
  [pageNameKey]: {
    done: "Fatto",
    indicatorIconAltText: "Icona Indicatore",
  },
};

export const resolvedAllNodesPillButtonEs = {
  [pageNameKey]: {
    done: "Hecho",
    indicatorIconAltText: "Icono indicador",
  },
};

export const resolvedAllNodesPillButtonNl = {
  [pageNameKey]: {
    done: "Klaar",
    indicatorIconAltText: "Indicatorpictogram",
  },
};

export const resolvedAllNodesPillButtonTr = {
  [pageNameKey]: {
    done: "Tamamlamak",
    indicatorIconAltText: "Gösterge Simgesi",
  },
};
